import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-top-add-hover",
  "use": "icon-icon-top-add-hover-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-top-add-hover\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M0 0h16v16H0z\" /><path d=\"M8 2a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2H9v4a1 1 0 0 1-2 0V8.999L3 9a1 1 0 1 1 0-2l4-.001V3a1 1 0 0 1 1-1z\" fill=\"#4C556C\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol